// @flow
import * as React from 'react';

import { Sun, Moon } from 'lucide-react';

import { Button, Icon, useTheme } from 'reshaped';

import { useFeatureFlag } from 'src/hooks/useFeatureFlag';

export function ThemeToggle(): React.Node {
  const { colorMode, setColorMode } = useTheme();
  const isDark = colorMode === 'dark';

  const FF_DARK = useFeatureFlag('ff-dark');
  const showToggle = FF_DARK || isDark;

  if (!showToggle) return null;

  return (
    <Button
      variant="ghost"
      size="small"
      icon={<Icon svg={isDark ? Sun : Moon} size={4} />}
      attributes={{
        title: isDark ? 'Switch to light mode' : 'Switch to dark mode',
      }}
      onClick={() => setColorMode(isDark ? 'light' : 'dark')}
    />
  );
}
